export const AppViewDevices = {
    IOS: 'iOS',
    ANDROID: 'Android',
} as const;
